import { KeenSliderOptions } from 'keen-slider';

/**
 * Base configuration shared by the mobile feed sliders: the vertical item feed
 * (xplore-page) and the horizontal media slider nested inside each card
 * (mobile-item-card).
 */
export function createFeedSliderOptions(overrides: KeenSliderOptions = {}): KeenSliderOptions {
  return {
    loop: false,
    rubberband: true,
    renderMode: 'performance',
    slides: {
      origin: 'center',
      perView: 1,
      spacing: 0,
    },
    selector: selectDirectSlides,
    ...overrides,
  };
}

/**
 * Includes only direct children as slides. Required because the sliders are
 * nested: a descendant selector would make the outer slider pick up the inner
 * slider's slides too.
 */
function selectDirectSlides(container: HTMLElement): HTMLElement[] {
  return Array.from(container.children).filter(
    (element): element is HTMLElement =>
      element instanceof HTMLElement && element.classList.contains('keen-slider__slide')
  );
}
